import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Sep10State {
    tokens: { [home_domain: string]: string };
}

const initialState: Sep10State = {
    tokens: {},
};

const sep10Slice = createSlice({
    name: "sep10",
    initialState,
    reducers: {
        receivedSep10Token: (state,action:PayloadAction<any>) => {

            const tokenObject = action.payload;

            for (const [key, value] of Object.entries(tokenObject)) {
                state.tokens[key]=String(value)  
            }
          return state
          
        },
      },
});


export default sep10Slice.reducer;

export const {receivedSep10Token} = sep10Slice.actions;

